export function createFukushizaiContextGridService(deps) {
    // API 側の rowData 再反映と再描画を共通化します。
    function refreshGridApiRows(api, rows) {
        if (deps.isEmpty(api)) return;
        if (typeof api.stopEditing === "function") api.stopEditing();
        deps.setGridRowsByApi(api, rows);
        if (typeof api.refreshCells === "function") api.refreshCells({ force: true });
        if (typeof api.redrawRows === "function") api.redrawRows();
        if (typeof api.refreshHeader === "function") api.refreshHeader();
    }

    // 副資材 copy preview 中の編集可否を context 表示グリッドへ反映します。
    function refreshFukushizaiCopyPreviewGridEditLock(lock) {
        const targetPanels = deps.getTargetPanels();
        if (!Array.isArray(targetPanels) || targetPanels.length === 0) return;

        targetPanels.forEach((panelInfo) => {
            const api = deps.getGridApi(panelInfo);
            const typeCandidates = deps.resolveTypeCandidatesForPanel(panelInfo);
            if (!Array.isArray(typeCandidates) || typeCandidates.length === 0) return;

            let nextDefs = deps.createPanelColumnDefsByType(panelInfo, typeCandidates, lock);
            if (!Array.isArray(nextDefs) || nextDefs.length === 0) return;

            // preview lock 中は click edit も止めて明示的に編集不可へ寄せます。
            if (lock) {
                nextDefs = nextDefs.map((col) => {
                    if (deps.isEmpty(col) || typeof col !== "object") return col;
                    return {
                        ...col,
                        editable: false,
                        suppressClickEdit: true
                    };
                });
            }

            deps.setGridColDef(panelInfo, nextDefs);

            if (!deps.isEmpty(api)) {
                if (typeof api.stopEditing === "function") api.stopEditing();
                deps.setGridColumnDefsByApi(api, nextDefs);
                refreshGridApiRows(api, deps.getGridRows(panelInfo));
            }

            deps.scheduleGridDataRerender(panelInfo);
        });
    }

    // context 表示グリッドの rowData を API 側へ再反映します。
    function rerenderFukushizaiSectionGrids() {
        const targetPanels = deps.getTargetPanels();
        if (!Array.isArray(targetPanels) || targetPanels.length === 0) return;

        targetPanels.forEach((panelInfo) => {
            const api = deps.getGridApi(panelInfo);
            if (deps.isEmpty(api)) {
                deps.scheduleGridDataRerender(panelInfo);
                return;
            }

            refreshGridApiRows(api, deps.getGridRows(panelInfo));
            deps.scheduleGridDataRerender(panelInfo);
        });
    }

    // context 切替時に一度 row を外してから戻し、フォーカスや編集状態をリセットします。
    function resetFukushizaiContextDisplayGridRowState() {
        const targetPanels = deps.getTargetPanels();
        if (!Array.isArray(targetPanels) || targetPanels.length === 0) return;

        targetPanels.forEach((panelInfo) => {
            const api = deps.getGridApi(panelInfo);
            if (deps.isEmpty(api)) {
                deps.scheduleGridDataRerender(panelInfo);
                return;
            }

            const rows = deps.DeepCopy(deps.getGridRows(panelInfo) || []);
            try {
                if (typeof api.stopEditing === "function") api.stopEditing();
                if (typeof api.clearFocusedCell === "function") api.clearFocusedCell();
                deps.setGridRowsByApi(api, []);

                // 遅延実行は coordinator 経由に寄せ、呼び出し文脈の差を吸収します。
                deps.scheduleDeferred(() => {
                    refreshGridApiRows(api, rows);
                    deps.scheduleGridDataRerender(panelInfo);
                });
            } catch (e) {
                console.error(e);
            }
        });
    }

    // 副資材セクションの再描画を 1tick 遅延で予約します。
    function scheduleFukushizaiSectionGridRepaint() {
        deps.scheduleDeferred(() => {
            rerenderFukushizaiSectionGrids();
        });
    }

    return {
        refreshFukushizaiCopyPreviewGridEditLock,
        rerenderFukushizaiSectionGrids,
        resetFukushizaiContextDisplayGridRowState,
        scheduleFukushizaiSectionGridRepaint
    };
}
